import { useContext } from 'react'
import { DeploymentConfigCtx } from '@/context/DeploymentConfigContext'
import { useJoinStore } from '@/store/joinStore'

export interface Branding {
  companyName: string
  jobTitle: string
}

// Source-of-truth selector for header branding shown in InterviewScreen.
// Join flow (resolved present) wins; candidate flow falls back to the
// global DeploymentConfig. Both hooks are always called to keep React's
// hook order stable across renders.
export function useBranding(): Branding {
  const resolved = useJoinStore((s) => s.resolved)
  const cfg = useContext(DeploymentConfigCtx)

  if (resolved) {
    return {
      companyName: resolved.branding.companyName,
      jobTitle: resolved.branding.jobTitle,
    }
  }
  if (!cfg) {
    throw new Error(
      'useBranding requires DeploymentConfigProvider or join resolved data',
    )
  }
  return {
    companyName: cfg.company_name,
    jobTitle: cfg.job_title,
  }
}